<template>
  <manual-transaction-limits
    :manual-transaction-limits="manualTransactionLimits"
    :entities-by-id="entitiesById"
    :is-loading="isLoading"
    @save="onSaveLimit"
    @delete="onDeleteLimit"
  />
</template>

<script>
import { keyBy } from 'lodash';
import { API } from '@/utils/api';
import ManualTransactionLimits from '../components/ManualTransactionLimits.vue';

const LIST_LIMITS = '/$v/manual_transaction_limits/list.json';
const UPDATE_LIMIT = '/$v/manual_transaction_limits/update.json';
const DELETE_LIMIT = '/$v/manual_transaction_limits/delete.json';
const ENTITY_LIST = '/users/entity_list.json';

export default {
  components: {
    ManualTransactionLimits
  },
  data() {
    return {
      isLoading: false,
      manualTransactionLimits: [],
      entitiesById: {}
    }
  },
  mounted() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.isLoading = true;
      Promise.all([
        this.loadLimits(),
        this.loadEntities()
      ]).finally(() => {
        this.isLoading = false;
      })
    },

    loadLimits() {
      return API.call(LIST_LIMITS).then(r => this.manualTransactionLimits = r.data)
    },

    loadEntities() {
      return API.call(ENTITY_LIST, { with_base: 1 }).then(r => this.entitiesById = keyBy([...r.data, { text: 'Default', value: -1 }], 'value'))
    },

    onSaveLimit(transactionLimit) {
      this.isLoading = true
      return API.call(UPDATE_LIMIT, { transactionLimit }).then(() => this.loadLimits()).finally(() => {
        this.isLoading = false
      })
    },

    async onDeleteLimit(id) {
      const confirmation = await this.$root.$confirm('Confirm', `Delete limit #${id} ?`)

      if (confirmation) {
        this.isLoading = true
        return API.call(DELETE_LIMIT, { id }).then(() => this.loadLimits()).finally(() => {
          this.isLoading = false
        })
      }
    }
  }
}
</script>
